import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ArrowRight, Check } from "lucide-react";
import { RevealLine, Reveal } from "../lib/motion";
import { subscribeNewsletter } from "../lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await subscribeNewsletter({ email, name: name || undefined });
      setStatus("done");
      setEmail(""); setName("");
      toast.success("Iscrizione confermata. Controlla la tua email.");
    } catch {
      setStatus("idle");
      toast.error("Iscrizione non riuscita. Riprova.");
    }
  };

  return (
    <section id="newsletter" data-testid="newsletter-section" className="py-24 sm:py-32 bg-[var(--petrol)] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="overline !text-[var(--gold)] mb-6">Newsletter</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight">
            <RevealLine>Insight riservati,</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--gold)]">direttamente da un board.</RevealLine>
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-6 text-white/70 text-lg max-w-md">Ricevi analisi su AI Governance, rischio e trasformazione digitale. Niente spam — solo idee che contano.</p>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          {status === "done" ? (
            <Reveal className="flex items-center gap-4 border border-[var(--gold)]/40 p-8" data-testid="newsletter-success">
              <div className="w-12 h-12 rounded-full bg-[var(--gold)] text-[var(--petrol)] flex items-center justify-center shrink-0"><Check strokeWidth={2} /></div>
              <div>
                <div className="font-serif text-2xl">Iscrizione confermata</div>
                <p className="text-white/60 text-sm mt-1">Ti abbiamo inviato un'email di benvenuto.</p>
              </div>
            </Reveal>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="newsletter-form">
              <input data-testid="newsletter-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome (opzionale)"
                className="w-full bg-transparent border border-white/25 px-4 py-4 text-white placeholder-white/40 focus:border-[var(--gold)] outline-none" />
              <div className="flex flex-col sm:flex-row gap-3">
                <input data-testid="newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email*"
                  className="flex-1 bg-transparent border border-white/25 px-4 py-4 text-white placeholder-white/40 focus:border-[var(--gold)] outline-none" />
                <button data-testid="newsletter-submit" disabled={status === "loading"}
                  className="btn-fill inline-flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] bg-[var(--gold)] text-[var(--petrol)] px-8 py-4 disabled:opacity-60"
                  style={{ "--accent": "#ffffff" }}>
                  {status === "loading" ? <Loader2 size={16} className="animate-spin" /> : <>Iscriviti <ArrowRight size={16} strokeWidth={2} /></>}
                </button>
              </div>
              <p className="text-xs text-white/40">Iscrivendoti accetti di ricevere comunicazioni. Puoi disiscriverti in ogni momento.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
